import React, {useEffect, useState} from 'react';
import {BaseStyle} from "../../../../../styles/shared/BaseStyle";
import axios from "axios";
import {BASE_NAME} from "../../../../../services/utils/ApiUrls";
import moment from "moment";
import {getConfig} from "../../../../../services/utils/ConfigUtils";
import ResizableBox, {sumKey} from "../../utils/ResizableBox";
import {Backdrop, Card, CardContent, CardHeader, CircularProgress, Typography} from "@mui/material";
import {Pie} from "react-chartjs-2";
import clsx from "clsx";

const options = {
	responsive: true,
	plugins: {
		legend: {
			position: 'top',
		},
		title: {
			display: true,
			text: 'Numero di ticket complessivi per stato',
		},
	},
};

export const TicketStato = () => {
	const classes = BaseStyle();
	const [dataGrafico, setDataGrafico] = useState(new Date());
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState({
		labels: ['I love you'],
		datasets: [
			{
				label: 'Attendere prego ...',
				data: [3000],
				backgroundColor: [
					'rgba(255, 99, 132, 0.2)',
					'rgba(54, 162, 235, 0.2)',
					'rgba(255, 206, 86, 0.2)',
					'rgba(75, 192, 192, 0.2)',
					'rgba(153, 102, 255, 0.2)',
					'rgba(255, 159, 64, 0.2)',
				],
				borderColor: [
					'rgba(255, 99, 132, 1)',
					'rgba(54, 162, 235, 1)',
					'rgba(255, 206, 86, 1)',
					'rgba(75, 192, 192, 1)',
					'rgba(153, 102, 255, 1)',
					'rgba(255, 159, 64, 1)',
				],
				borderWidth: 1,
			},
		],
	})
	
	useEffect(() => {
		setDataGrafico(new Date())
	}, [])
	
	useEffect(() => {
		setLoading(true);
		axios
			.get(BASE_NAME + "ticket/getStatsByDate/" + moment(dataGrafico).format("DD-MM-YYYY"), getConfig())
			.then((response) => {
				let newData = {
					labels: ['Nuovi', 'Aperti', 'Presi in carico', 'In attesa', 'Risolti'],
					datasets: [
						{
							label: 'Numero totale di Tickets',
							data: [
								sumKey(response.data, "Nuovi"),
								sumKey(response.data, "Aperti"),
								sumKey(response.data, "Presi in carico"),
								sumKey(response.data, "In attesa"),
								sumKey(response.data, "Risolti"),
							],
							backgroundColor: [
								'rgba(255, 99, 132, 0.2)',
								'rgba(54, 162, 235, 0.2)',
								'rgba(255, 206, 86, 0.2)',
								'rgba(75, 192, 192, 0.2)',
								'rgba(153, 102, 255, 0.2)',
								'rgba(255, 159, 64, 0.2)',
							],
							borderColor: [
								'rgba(255, 99, 132, 1)',
								'rgba(54, 162, 235, 1)',
								'rgba(255, 206, 86, 1)',
								'rgba(75, 192, 192, 1)',
								'rgba(153, 102, 255, 1)',
								'rgba(255, 159, 64, 1)',
							],
							borderWidth: 1,
						},
					],
				}
				
				setData(newData);
				setLoading(false)
				console.log(response.data)
			})
			.catch((error) => {
				setLoading(false);
				console.log(JSON.stringify(error))
			})
	}, [dataGrafico])
	
	return (
		<React.Fragment>
			<Backdrop open={loading} className={classes.backdrop}>
				<CircularProgress/>
			</Backdrop>
			
			<Card className={clsx(classes.roundBorder)}
			      style={{height: "100%", display: "flex", flexDirection: "column"}}>
				<CardHeader
					title={<Typography variant={"h6"}><b>Ticket stato</b></Typography>}
					subheader={"Numero di ticket complessivi per stato (colore torta)"}
				/>
				<CardContent style={{flexGrow: 1, overflow: "scroll"}}>
					
					<ResizableBox width={600} height={600}>
						<Pie data={data} type={"pie"} options={options}/>
					</ResizableBox>
				
				</CardContent>
			</Card>
		
		</React.Fragment>
	);
}
